import React, { ChangeEvent, FocusEvent } from "react";
import classes from "./Checkbox.module.scss";
import classnames from "classnames";

export const Checkbox = ({
  className,
  classNameChecked,
  classNameContainer,
  id,
  testId,
  ...props
}: {
  name?: string;
  className?: string;
  classNameChecked?: string;
  classNameContainer?: string;
  value?: boolean;
  disabled?: boolean;
  size?: "normal" | "large";
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement, Element>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  id?: string;
  testId?: string;
}) => (
  <div className={classnames(classes.CheckboxContainer, classNameContainer, { [classes.large]: props.size === "large" })}>
    <input
      id={id}
      data-testid={testId}
      type="checkbox"
      className={classnames(classes.HiddenCheckbox)}
      onChange={props.onChange}
      checked={props.value}
      name={props.name}
      disabled={props.disabled}
      onClick={props.onClick}
    />
    <div
      className={classnames(classes.StyledCheckbox, className, {
        [classes.checked]: props.value,
        [classNameChecked ?? ""]: props.value,
        [classes.disabled]: props.disabled,
      })}
    >
      {props.value && (
        <div className={classes.svgContainer}>
          <svg style={{ display: "flex" }} height="100%" width="100%" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.01603 0.78996C7.26106 1.04327 7.26106 1.45397 7.01603 1.70729L3.62779 5.20999C3.38276 5.4633 2.98548 5.4633 2.74044 5.20999L0.983581 3.39377C0.738546 3.14046 0.738546 2.72976 0.983581 2.47645C1.22862 2.22313 1.6259 2.22313 1.87093 2.47645L3.18412 3.834L6.12868 0.78996C6.37371 0.536647 6.77099 0.536647 7.01603 0.78996Z"
              fill="white"
            />
          </svg>
        </div>
      )}
    </div>
  </div>
);
